import { apiSlice } from '../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['packages'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllPackages: builder.query({
        query: (fishery_id) => ({
          url: 'booking/fishery/reservation-packages',
          method: 'GET',
          params: { fishery_id },
        }),
        providesTags: ['packages'],
      }),
      getPackagesDetailsById: builder.query({
        query: ({ fishery_id, package_id }) => ({
          url: 'booking/fishery/reservation-packages',
          method: 'GET',
          params: { fishery_id: fishery_id, package_id: package_id },
        }),
        providesTags: ['packages'],
      }),
      getQuoteDetailsById: builder.query({
        query: ({ package_id }) => ({
          url: `fishery/fishery-quotes/${package_id}`,
          method: 'GET',
          // params: { fishery_id: fishery_id, package_id: package_id },
        }),
        providesTags: ['packages'],
      }),
    }),
  });

export const {
  useGetAllPackagesQuery,
  useGetPackagesDetailsByIdQuery,
  useGetQuoteDetailsByIdQuery,
} = extendedApiSlice;
